import CryptoJS from "crypto-js";
const KEY = process.env.REACT_APP_SECRET;

export const encrypt = (item) => {
    const encrypted = CryptoJS.AES.encrypt(item, KEY);
    return encrypted;
}

export const decrypt = (item) => {
    const decrypted = CryptoJS.AES.decrypt(item, KEY);
    return decrypted.toString(CryptoJS.enc.Utf8);
};

const cipher = {
    encrypt,
    decrypt
};

export default cipher;
